import React, { useContext, useMemo } from 'react';
import { CardBody } from '../../shared/card/card-body';
import { Button, Icon } from '../../shared';
import './case-applicants.scss';
import { services } from '../../../shared';
import saveAs from 'file-saver';
import { DefaultLoadingComponent } from '../../../shared/utils/loader/default-loading-component';
import { LoaderContext } from '../../../shared/utils/loader/loader-wrapper';
import { useLoader } from '../../../shared/utils';
export var CaseApplicantsDetailsBody = function (_a) {
    var documents = _a.documents;
    var data = useContext(LoaderContext);
    var isLoading = useMemo(function () { return data.isLoading; }, [data.isLoading]);
    var getCustomerDocument = function (id, description, mimeType) {
        services.getCustomerDocument(id).then(function (blob) {
            saveAs(blob, "".concat(description, ".").concat(mimeType === null || mimeType === void 0 ? void 0 : mimeType.split('/')[1]));
        });
    };
    var caseApplicantDocumentsIsLoading = useLoader({ identifier: 'caseApplicantDocuments' }).caseApplicantDocumentsIsLoading;
    var _documents = useMemo(function () {
        return isLoading || caseApplicantDocumentsIsLoading ? [1] : documents;
    }, [documents, isLoading, caseApplicantDocumentsIsLoading]);
    if (_documents.length) {
        var list = _documents === null || _documents === void 0 ? void 0 : _documents.map(function (_a) {
            var id = _a.id, description = _a.description, mimeType = _a.mimeType;
            return (React.createElement("div", { className: "s-card-client__detail", key: id },
                isLoading || caseApplicantDocumentsIsLoading ? (React.createElement(DefaultLoadingComponent, { height: '1.2rem', width: '1.2rem', style: { borderRadius: '50%' } })) : (React.createElement("span", { className: "doc-upload__success" },
                    React.createElement(Icon, { name: "tick", colour: "primary" }))),
                React.createElement("div", { className: "s-card-client__detail__content" },
                    React.createElement("span", { style: { flex: 'none', marginRight: 0 } }, isLoading || caseApplicantDocumentsIsLoading ? React.createElement(DefaultLoadingComponent, null) : description)),
                isLoading || caseApplicantDocumentsIsLoading ? (React.createElement(DefaultLoadingComponent, null)) : (React.createElement(Button, { type: "button", variant: "secondary", icon: 'download', iconPosition: "left", size: "small", onClick: function () { return getCustomerDocument(id, description, mimeType); } }, "Download"))));
        });
        return React.createElement(CardBody, null, list);
    }
    return React.createElement(CardBody, null, 'No Documents');
};
